import { render, staticRenderFns } from "./TableButtonsCopyObjectsGeometryErrorsDialog.vue?vue&type=template&id=d726e2e2&"
import script from "./TableButtonsCopyObjectsGeometryErrorsDialog.vue?vue&type=script&lang=js&"
export * from "./TableButtonsCopyObjectsGeometryErrorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports